import RatioIcon1 from '../../assets/svg/1-1.svg?react';
import RatioIcon2 from '../../assets/svg/2-3.svg?react';
import RatioIcon3 from '../../assets/svg/3-2.svg?react';
import RatioIcon4 from '../../assets/svg/4-5.svg?react';

// 生成大分类
export const GENERATION_CATEGORIES = {
    SPECIFIC_THEME: 'specific-theme', // 具体主题，例如职业，杂志，节日等
    PROFESSIONAL_HEADSHOT: 'professional-headshot', // 专业头像, 包含发型，服装，背景，比例等
    OCCUPATIONAL: 'occupational', // 职业照，多一步职业选择
    KID: 'kid', // 儿童，类似具体主题，多一步年龄选择
};

// 头像生成分类
export const GENERATION_CATEGORIES_OPTIONS = [
    {
        value: GENERATION_CATEGORIES.PROFESSIONAL_HEADSHOT,
        key: 'professional',
        imageUrl: 'category/professional.png',
    },
    {
        value: GENERATION_CATEGORIES.SPECIFIC_THEME,
        key: 'christmas',
        imageUrl: 'category/christmas.png',
    },
    {
        value: GENERATION_CATEGORIES.KID,
        key: 'christmas-kid',
        imageUrl: 'category/christmas-kid.png',
    },
    {
        value: GENERATION_CATEGORIES.SPECIFIC_THEME,
        key: 'yearbook',
        imageUrl: 'category/yearbook.png',
    },
    {
        value: GENERATION_CATEGORIES.SPECIFIC_THEME,
        key: 'old-money',
        imageUrl: 'category/old-money.png',
    },
    {
        value: GENERATION_CATEGORIES.OCCUPATIONAL,
        key: 'occupational',
        imageUrl: 'category/lawyer.png',
    },
    {
        value: GENERATION_CATEGORIES.SPECIFIC_THEME,
        key: 'magazine',
        imageUrl: 'category/magazine.png',
    },
    {
        value: GENERATION_CATEGORIES.SPECIFIC_THEME,
        key: 'travel',
        imageUrl: 'category/travel.png',
    },
    {
        value: GENERATION_CATEGORIES.SPECIFIC_THEME,
        key: 'creative',
        imageUrl: 'category/creative.png',
    },
    {
        value: GENERATION_CATEGORIES.SPECIFIC_THEME,
        key: 'wedding',
        imageUrl: 'category/wedding.png',
    },
    {
        value: GENERATION_CATEGORIES.SPECIFIC_THEME,
        key: 'graduation',
        imageUrl: 'category/graduation.png',
    },
    {
        value: GENERATION_CATEGORIES.KID,
        key: 'kid',
        imageUrl: 'category/kid.png',
    },
    {
        value: GENERATION_CATEGORIES.SPECIFIC_THEME,
        key: 'dating',
        imageUrl: 'category/dating.png',
    },
    {
        value: GENERATION_CATEGORIES.SPECIFIC_THEME,
        key: 'halloween',
        imageUrl: 'category/halloween.png',
    },
];

// 性别选项
export const GENDER_OPTIONS = {
    MALE: 'male',
    FEMALE: 'female',
};

// 具体职业选项
export const PROFESSION_OPTIONS = [
    {
        key: 'male-realtor',
        value: 'realtor',
        imageUrl: 'profession/male_realtor.png',
        gender: GENDER_OPTIONS.MALE,
    },
    {
        key: 'male-medical',
        value: 'healthcare',
        imageUrl: 'profession/male_healthcare.png',
        gender: GENDER_OPTIONS.MALE,
    },
    {
        key: 'male-lawyer',
        value: 'lawyer',
        imageUrl: 'profession/male_lawyer.png',
        gender: GENDER_OPTIONS.MALE,
    },
    {
        key: 'male-teacher',
        value: 'teacher',
        imageUrl: 'profession/male_teacher.png',
        gender: GENDER_OPTIONS.MALE,
    },
    {
        key: 'female-realtor',
        value: 'realtor',
        imageUrl: 'profession/female_realtor.png',
        gender: GENDER_OPTIONS.FEMALE,
    },
    {
        key: 'female-medical',
        value: 'healthcare',
        imageUrl: 'profession/female_healthcare.png',
        gender: GENDER_OPTIONS.FEMALE,
    },
    {
        key: 'female-lawyer',
        value: 'lawyer',
        imageUrl: 'profession/female_lawyer.png',
        gender: GENDER_OPTIONS.FEMALE,
    },
    {
        key: 'female-teacher',
        value: 'teacher',
        imageUrl: 'profession/female_teacher.png',
        gender: GENDER_OPTIONS.FEMALE,
    },
];

// 发型和发色偏好
export const HAIR_COLOR_NO_CHANGE = 'no-change';
export const HAIR_STYLE_NO_CHANGE = 'no-change';
export const HAIR_STYLES_PREFERENCES = [
    {
        key: 'no-change',
        value: HAIR_STYLE_NO_CHANGE,
        imageUrl: 'hair/male_hair_no-change.png',
        gender: GENDER_OPTIONS.MALE,
    },
    {
        key: 'no-change',
        value: HAIR_STYLE_NO_CHANGE,
        imageUrl: 'hair/female_hair_no-change.png',
        gender: GENDER_OPTIONS.FEMALE,
    },
    // {
    //     key: 'male-buzz-cut',
    //     value: 'buzz-cut',
    //     imageUrl: 'hair/male_hair_buzz-cut.png',
    //     gender: GENDER_OPTIONS.MALE,
    // },
    {
        key: 'male-short',
        value: 'short',
        imageUrl: 'hair/male_hair_short.png',
        gender: GENDER_OPTIONS.MALE,
    },
    {
        key: 'male-medium-length',
        value: 'medium-length',
        imageUrl: 'hair/male_hair_medium-length.png',
        gender: GENDER_OPTIONS.MALE,
    },
    {
        key: 'male-long',
        value: 'long',
        imageUrl: 'hair/male_hair_long.png',
        gender: GENDER_OPTIONS.MALE,
    },
    {
        key: 'female-short',
        value: 'pixie-cut',
        imageUrl: 'hair/female_hair_pixie-cut.png', // 更新了选项，但是保留了这个图片路径
        gender: GENDER_OPTIONS.FEMALE,
    },
    {
        key: 'female-medium-length',
        value: 'medium-length',
        imageUrl: 'hair/female_hair_bob-cut.png',
        gender: GENDER_OPTIONS.FEMALE,
    },
    // {
    //     key: 'female-medium-length',
    //     value: 'medium-length',
    //     imageUrl: 'hair/female_hair_medium-length.png',
    //     gender: GENDER_OPTIONS.FEMALE,
    // },
    {
        key: 'female-long',
        value: 'long',
        imageUrl: 'hair/female_hair_long.png',
        gender: GENDER_OPTIONS.FEMALE,
    },
];

export const HAIR_COLORS_PREFERENCES = [
    { key: 'light-brown', value: 'Light Brown', imageUrl: 'light-brown.png' },
    { key: 'honey-blonde', value: 'Honey Blonde', imageUrl: 'honey-blonde.png' },
    { key: 'black', value: 'Black', imageUrl: 'black.png' },
    { key: 'white', value: 'White', imageUrl: 'white.png' },
    { key: 'red', value: 'Red', imageUrl: 'red.png' },

    { key: 'burgundy', value: 'Burgundy', imageUrl: 'burgundy.png' },
    { key: 'dark-brown', value: 'Dark Brown', imageUrl: 'dark-brown.png' },

    { key: 'medium-brown', value: 'Medium Brown', imageUrl: 'medium-brown.png' },
    { key: 'copper', value: 'Copper', imageUrl: 'copper.png' },
    { key: 'auburn', value: 'Auburn', imageUrl: 'auburn.png' },

    { key: 'caramel', value: 'Caramel', imageUrl: 'caramel.png' },
    { key: 'blonde', value: 'Blonde', imageUrl: 'blonde.png' },
    { key: 'ash-blonde', value: 'Ash Blonde', imageUrl: 'ash-blonde.png' },
    { key: 'platinum-blonde', value: 'Platinum Blonde', imageUrl: 'platinum-blonde.png' },

    { key: 'blue', value: 'Blue', imageUrl: 'blue.png' },
    { key: 'blue-black', value: 'Blue-Black', imageUrl: 'blue-black.png' },
    { key: 'green', value: 'Green', imageUrl: 'green.png' },
    { key: 'purple', value: 'Purple', imageUrl: 'purple.png' },
    { key: 'pink', value: 'Pink', imageUrl: 'pink.png' },
    { key: 'strawberry-blonde', value: 'Strawberry Blonde', imageUrl: 'strawberry-blonde.png' },
    { key: 'rose-gold', value: 'Rose Gold', imageUrl: 'rose-gold.png' },

    { key: 'jet-black', value: 'Jet Black', imageUrl: 'jet-black.png' },
    { key: 'silver', value: 'Silver', imageUrl: 'silver.png' },
    { key: 'titanium', value: 'Titanium', imageUrl: 'titanium.png' },
];

// 服装偏好
export const CLOTHING_PREFERENCES = [
    {
        key: 'male-business',
        value: 'business',
        imageUrl: 'attire/male_attire_business.png',
        gender: GENDER_OPTIONS.MALE,
    },
    {
        key: 'male-business-casual',
        value: 'business-casual',
        imageUrl: 'attire/male_attire_business-casual.png',
        gender: GENDER_OPTIONS.MALE,
    },
    {
        key: 'male-smart-casual',
        value: 'smart-casual',
        imageUrl: 'attire/male_attire_smart-casual.png',
        gender: GENDER_OPTIONS.MALE,
    },
    {
        key: 'female-business',
        value: 'business',
        imageUrl: 'attire/female_attire_business.png',
        gender: GENDER_OPTIONS.FEMALE,
    },
    {
        key: 'female-business-casual',
        value: 'business-casual',
        imageUrl: 'attire/female_attire_business-casual.png',
        gender: GENDER_OPTIONS.FEMALE,
    },
    {
        key: 'female-smart-casual',
        value: 'smart-casual',
        imageUrl: 'attire/female_attire_smart-casual.png',
        gender: GENDER_OPTIONS.FEMALE,
    },
];

// 背景偏好
export const BACKGROUND_PREFERENCES = [
    {
        key: 'male-city',
        value: 'city',
        imageUrl: 'background/male_background_city.png',
        gender: GENDER_OPTIONS.MALE,
    },
    {
        key: 'male-nature',
        value: 'nature',
        imageUrl: 'background/male_background_nature.png',
        gender: GENDER_OPTIONS.MALE,
    },
    {
        key: 'male-office',
        value: 'office',
        imageUrl: 'background/male_background_office.png',
        gender: GENDER_OPTIONS.MALE,
    },
    {
        key: 'male-studio',
        value: 'studio',
        imageUrl: 'background/male_background_studio.png',
        gender: GENDER_OPTIONS.MALE,
    },
    {
        key: 'female-city',
        value: 'city',
        imageUrl: 'background/female_background_city.png',
        gender: GENDER_OPTIONS.FEMALE,
    },
    {
        key: 'female-nature',
        value: 'nature',
        imageUrl: 'background/female_background_nature.png',
        gender: GENDER_OPTIONS.FEMALE,
    },
    {
        key: 'female-office',
        value: 'office',
        imageUrl: 'background/female_background_office.png',
        gender: GENDER_OPTIONS.FEMALE,
    },
    {
        key: 'female-studio',
        value: 'studio',
        imageUrl: 'background/female_background_studio.png',
        gender: GENDER_OPTIONS.FEMALE,
    },
];

// 比例选项
export const SHOT_OPTIONS = [
    {
        key: 'male-close-up',
        value: 'close-up',
        imageUrl: 'shot/male_shot_close-up.png',
        gender: GENDER_OPTIONS.MALE,
    },
    {
        key: 'male-waist',
        value: 'waist',
        imageUrl: 'shot/male_shot_waist.png',
        gender: GENDER_OPTIONS.MALE,
    },
    {
        key: 'male-full-length',
        value: 'full-length',
        imageUrl: 'shot/male_shot_full-length.png',
        gender: GENDER_OPTIONS.MALE,
    },
    {
        key: 'female-close-up',
        value: 'close-up',
        imageUrl: 'shot/female_shot_close-up.png',
        gender: GENDER_OPTIONS.FEMALE,
    },
    {
        key: 'female-waist',
        value: 'waist',
        imageUrl: 'shot/female_shot_waist.png',
        gender: GENDER_OPTIONS.FEMALE,
    },
    {
        key: 'female-full-length',
        value: 'full-length',
        imageUrl: 'shot/female_shot_full-length.png',
        gender: GENDER_OPTIONS.FEMALE,
    },
];

export const RATIO_OPTIONS = [
    {
        key: '2-3',
        value: '2:3',
        width: 1366,
        height: 2048,
        icon: RatioIcon2,
    },
    {
        key: '1-1',
        value: '1:1',
        width: 2048,
        height: 2048,
        icon: RatioIcon1,
    },
    {
        key: '3-2',
        value: '3:2',
        width: 2048,
        height: 1366,
        icon: RatioIcon3,
    },
    {
        key: '4-5',
        value: '4:5',
        width: 1640,
        height: 2048,
        icon: RatioIcon4,
    },
];

// 题材选项（杂志/创造性/旅行/年鉴/老钱/律师/医生/教师/房地产）
export const THEME_OPTIONS = {
    yearbook: {
        path: 'yearbook',
        male: 8,
        female: 8,
    },
    'old-money': {
        path: 'old-money',
        male: 16,
        female: 16,
    },
    travel: {
        path: 'travel',
        male: 22,
        female: 23,
    },
    creative: {
        path: 'creative',
        male: 26,
        female: 29,
    },
    magazine: {
        path: 'magazine',
        male: 29,
        female: 30,
    },
    lawyer: {
        path: 'lawyer',
        male: 7,
        female: 7,
    },
    healthcare: {
        path: 'healthcare',
        male: 6,
        female: 6,
    },
    teacher: {
        path: 'teacher',
        male: 6,
        female: 6,
    },
    realtor: {
        path: 'realtor',
        male: 8,
        female: 8,
    },
    wedding: {
        path: 'wedding',
        male: 26,
        female: 27,
    },
    graduation: {
        path: 'graduation',
        male: 22,
        female: 22,
    },
    halloween: {
        path: 'halloween',
        male: 12,
        female: 18,
    },
    kid: {
        path: 'kid',
        male: 42,
        female: 44,
    },
    dating: {
        path: 'dating',
        male: 33,
        female: 32,
    },
    christmas: {
        path: 'christmas',
        male: 21,
        female: 25,
    },
    'christmas-kid': {
        path: 'christmas-kid',
        male: 23,
        female: 26,
    },
};

// 年龄选项
export const AGE_OPTIONS = [
    {
        key: '0-2-years-old',
        value: '0-2',
    },
    {
        key: '2-3-years-old',
        value: '2-3',
    },
    {
        key: '3-4-years-old',
        value: '3-4',
    },
    {
        key: '5-6-years-old',
        value: '5-6',
    },
    {
        key: '7-8-years-old',
        value: '7-8',
    },
    {
        key: '8-10-years-old',
        value: '8-10',
    },
    {
        key: '10-13-years-old',
        value: '10-13',
    },
];

// 动态步骤配置
export const DYNAMIC_STEPS_CONFIG = {
    [GENERATION_CATEGORIES.PROFESSIONAL_HEADSHOT]: [
        { key: 'category' },
        { key: 'gender' },
        { key: 'hair' },
        { key: 'clothing' },
        { key: 'background', multiple: true },
        { key: 'ratio' },
        { key: 'upload' },
        { key: 'generate' },
    ],
    [GENERATION_CATEGORIES.KID]: [
        { key: 'category' },
        { key: 'gender' },
        { key: 'age' },
        { key: 'theme', multiple: true },
        { key: 'upload' },
        { key: 'generate' },
    ],
    [GENERATION_CATEGORIES.SPECIFIC_THEME]: [
        { key: 'category' },
        { key: 'gender' },
        { key: 'theme', multiple: true },
        { key: 'upload' },
        { key: 'generate' },
    ],
    [GENERATION_CATEGORIES.OCCUPATIONAL]: [
        { key: 'category' },
        { key: 'gender' },
        { key: 'profession' },
        { key: 'theme', multiple: true },
        { key: 'upload' },
        { key: 'generate' },
    ],
};
// 默认配置
export const DEFAULT_CONFIG = {
    category: GENERATION_CATEGORIES_OPTIONS[0].value,
    categoryKey: GENERATION_CATEGORIES_OPTIONS[0].key,
    gender: GENDER_OPTIONS.MALE,
    profession: PROFESSION_OPTIONS.BUSINESS,
    hairPreferences: {
        style: HAIR_STYLE_NO_CHANGE,
        color: {
            value: HAIR_COLOR_NO_CHANGE,
            key: HAIR_COLOR_NO_CHANGE,
        },
    },
    clothingPreference: CLOTHING_PREFERENCES[0],
    backgroundPreference: [BACKGROUND_PREFERENCES[0]],
    theme: [],
    ratio: RATIO_OPTIONS[0],
    shot: SHOT_OPTIONS[1],
    totalOutput: 20,
    selectedAge: AGE_OPTIONS[0],
};

// 男性默认配置
export const DEFAULT_MALE_CONFIG = {
    category: GENERATION_CATEGORIES_OPTIONS[0].value,
    categoryKey: GENERATION_CATEGORIES_OPTIONS[0].key,
    gender: GENDER_OPTIONS.MALE,
    profession: PROFESSION_OPTIONS.BUSINESS,
    hairPreferences: {
        style: HAIR_STYLE_NO_CHANGE,
        color: HAIR_COLOR_NO_CHANGE,
    },
    clothingPreference: null,
    theme: [],
    ratio: RATIO_OPTIONS[0],
    shot: SHOT_OPTIONS[1],
    totalOutput: 20,
    selectedAge: AGE_OPTIONS[0],
};

// 女性默认配置
export const DEFAULT_FEMALE_CONFIG = {
    category: GENERATION_CATEGORIES_OPTIONS[0].value,
    categoryKey: GENERATION_CATEGORIES_OPTIONS[0].key,
    gender: GENDER_OPTIONS.FEMALE,
    profession: PROFESSION_OPTIONS.BUSINESS,
    hairPreferences: {
        style: HAIR_STYLE_NO_CHANGE,
        color: HAIR_COLOR_NO_CHANGE,
    },
    clothingPreference: null,
    theme: [],
    ratio: RATIO_OPTIONS[0],
    shot: SHOT_OPTIONS[5],
    totalOutput: 20,
    selectedAge: AGE_OPTIONS[0],
};
